import React, { useMemo } from 'react';
import { FaIcon } from '../../../common/Icons.jsx';
import { widgetIconManifest } from './widgetIconManifest.js';
import styles from './WidgetPreview.module.scss';

function WidgetPreview({widget}) {
  const {title, displayedType} = useMemo(() => {
    if (widget.existing_widget) { // Cloneable existing widget
      return {
        title: (
          widget?.theme?.overrides?.common?.title?.text ||
          widget?.settings?.gaugeOptions?.title?.text ||
          widget?.settings?.chartOptions?.title?.text ||
          widget?.settings?.title
        ),
        displayedType: widget?.settings?.title || widget?.widget_type
      }
    } else { // preview widget
      return {
        title: widget?.settings?.title || widget?.type,
        displayedType: null
      }
    }
  }, [
    widget?.theme?.overrides?.common?.title?.text,
    widget?.settings?.gaugeOptions?.title?.text,
    widget?.settings?.chartOptions?.title?.text,
    widget?.settings?.title
  ]);

  return (
    <div className='widget-container noselect' style={{height: 'fit-content', overflow: 'hidden'}}>
      <div
        className={`widget-template ${styles['widget-preview']} flex-dir-column`}
        data-type={widget.type}
        data-settings={JSON.stringify(widget.settings)}
        draggable={true}
        unselectable="on"
        onDragStart={e => {
          const type = e.currentTarget.getAttribute('data-type');
          e.dataTransfer.setData('widget-type', type);
          if (widget.existing_widget) {
            e.dataTransfer.setData('existing-widget-id', widget.id);
          }
        }}
      >
        <div className='d-flex' style={{gap: '0.5rem'}}>
          <FaIcon type={widgetIconManifest[widget.type || widget.widget_type] || 'puzzle-piece'} />
          <div className="title" style={{fontSize: 13}}><b>{title} {widget.existing_widget ? `(${widget.dashboard_count})` : ''}</b></div>
          {/* {displayedType && <div className='text-truncate'>{displayedType}</div>} */}
        </div>
        <div className="details description">{widget.settings.description}</div>
      </div>
    </div>
  );
}

export default WidgetPreview;